import { RouteComponent, AnyRoute, createRoute } from '@tanstack/react-router';
import { RouterContext } from './routes';

export interface RouteConfig {
  path: string;
  component: RouteComponent;
  children?: RouteConfig[];
  beforeLoad?: (opts: {
    context: RouterContext;
    params: Record<string, string>;
  }) => Promise<void> | void;
}

export const createRoutesFromConfig = (parent: AnyRoute, configs: RouteConfig[]) => {
  return configs.map(({ path, component, children, beforeLoad }) => {
    const route = createRoute({
      getParentRoute: () => parent,
      path,
      component,
      beforeLoad,
    });

    if (children && children.length) {
      const childRoutes = createRoutesFromConfig(route, children);
      route.addChildren(childRoutes);
    }

    return route;
  });
};
